






















import Vue from "vue";
import Component from "vue-class-component";
import { UserStore } from "../store";
import router, { ROUTES } from "../router";
import { BvModalEvent } from "bootstrap-vue";

@Component
export default class SessionTimeout extends Vue {
  timerid: number = 0;
  secondsLeft: number = 0;

  mounted() {
    this.$root.$on(
      "bv::modal::show",
      (bvEvent: string | string[], modalId: string) => {
        if (modalId === "modal-session-timout") {
          this.secondsLeft = 60;
          this.timerid = setInterval(() => {
            this.secondsLeft -= 1;
            if (this.secondsLeft === 0) {
              this.expired();
            }
          }, 1000);
        }
      }
    );
  }

  prevent(e: BvModalEvent) {
    if (this.ShowDialog) e.preventDefault();
  }

  get ShowDialog(): boolean {
    return UserStore.ShowSessionTimeout;
  }

  set ShowDialog(val: boolean) {
    // Setter required for modal v-model property
  }

  get TimeLeft(): number {
    return this.secondsLeft;
  }

  async login() {
    clearInterval(this.timerid);
    await UserStore.RefreshAuthToken();
  }

  async expired() {
    clearInterval(this.timerid);
    router.push({ name: ROUTES.sessionTimeout });
  }

  async logout() {
    router.push({ name: ROUTES.logout });
  }
}
